import type { Pair } from '../messages';

/** The library screen: its filters, counters and empty states. */
export const library = {
  'library.saved': ['Сохранённое вами · показано {n}', 'Saved by you · {n} shown'],
  'library.searchAria': ['Поиск по библиотеке', 'Search your library'],
  'library.searchPlaceholder': ['Название, описание, домен…', 'Title, description, domain…'],
  'library.filterType': ['Фильтр по типу', 'Filter by type'],
  'library.filterStatus': ['Фильтр по статусу', 'Filter by status'],
  'library.all': ['Все', 'All'],
  'library.anyStatus': ['Любой статус', 'Any status'],
  'library.nothingFound': ['Ничего не нашлось', 'Nothing matched'],
  'library.isEmpty': ['Библиотека пуста', 'Your library is empty'],
  'library.nothingFoundHint': ['Попробуйте другой запрос или снимите фильтры.', 'Try another query, or clear the filters.'],
  'library.isEmptyHint': ['Начните с одной ссылки — остальное парсер подтянет сам.', 'Start with a single link — the rest is fetched for you.'],
  'library.resetFilters': ['Сбросить фильтры', 'Clear filters'],
  'library.addFirst': ['Добавить первую ссылку', 'Add your first link'],
  'library.showMore': ['Показать ещё', 'Show more'],
  'library.endOfList': ['На этом всё', 'That is everything'],
  'library.filterCleared': [
    'Сохранено — фильтр сброшен, чтобы карточку было видно',
    'Saved — the filter was cleared so you can see the card',
  ],
} satisfies Record<string, Pair>;
